<template>
    <footer>
    </footer>
</template>
<script>
export default {
    name: 'TaxitFooter',
}
</script>
